import type { ReactNode } from "react"
import { motion } from "motion/react"

import { cn } from "@productlane/lib/src/cn"

import { joinTypingNames } from "../../hooks/useTypingUsers"

interface Props {
	className?: string
	names?: string[]
	// Pre-built, localized label. Overrides the English one derived from names.
	label?: string
	avatar?: ReactNode
}

export const TypingProgress = (props: Props) => {
	const { className, names = [], label, avatar } = props

	const text =
		label ??
		(names.length === 0
			? null
			: names.length === 1
				? `${names[0]} is typing`
				: `${joinTypingNames(names)} are typing`)

	return (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			className={cn("flex items-center justify-start gap-2", className)}
		>
			{avatar ? <div className="flex-shrink-0">{avatar}</div> : null}
			<div className="flex items-center gap-1.5">
				{text && (
					<span className="text-xs text-gray-500 dark:text-gray-400">
						{text}
					</span>
				)}
				<div className="flex h-4 items-center gap-[3px]">
					{[0, 1, 2].map((i) => (
						<motion.span
							key={i}
							className="size-1 flex-none rounded-full bg-gray-400 dark:bg-gray-500"
							animate={{ opacity: [0.3, 1, 0.3] }}
							transition={{
								duration: 1.2,
								repeat: Infinity,
								ease: "easeInOut",
								delay: i * 0.2,
							}}
						/>
					))}
				</div>
			</div>
		</motion.div>
	)
}
